export class WebhookV1StandardPayloadViolationsArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "violationsDetectionNotificationArguments",
            "baseName": "violationsDetectionNotificationArguments",
            "type": "WebhookV1ViolationsDetectionNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadViolationsArguments.attributeTypeMap;
    }
    constructor() {
    }
}
